<div class="overlay loading-overlay" id="loading-overlay">
  <span class="overlay_spinner rotate"></span>
</div>
